import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './responsive.css';
import AppRoutes from './routes/AppRoutes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRoutes />    
  </React.StrictMode>
);


